import React, { useState } from 'react';
import { Typography, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { motion } from 'framer-motion';
import { MdExpandMore } from "react-icons/md";
import { useTranslation } from 'react-i18next';

const FAQ = () => {
    const { t } = useTranslation();
    const [expanded, setExpanded] = useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };
    return (
        <>
            {Array(6).fill(0).map((_, index) => {
                const id = `accordion-item-${index}`;
                return (
                    <Accordion
                        key={id}
                        className='pretty-text'
                        expanded={expanded === id}
                        onChange={handleChange(id)}
                        sx={{
                            mb: 2,
                            background: expanded === id ? '#10151eff' : '#0b0e14',
                            border: '1px solid rgba(51, 59, 77, 0.6)',
                            borderRadius: '8px !important',
                            '&:before': { display: 'none' },
                            width: '100%'
                        }}
                        component={motion.div}
                        initial={{ opacity: 0, y: 10 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: index * 0.1 }}
                    >
                        <AccordionSummary expandIcon={<MdExpandMore />}>
                            <Typography sx={{ fontWeight: 'bold', color: 'text.primary' }}>
                                {t(`home.faq.question${index + 1}`)}
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography variant='body2' sx={{ color: 'text.secondary' }}>
                                {t(`home.faq.answer${index + 1}`)}
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                )
            })}
        </>
    )
}

export default FAQ